import { useSelector } from 'react-redux';
import MenuExpediente from './menuExpediente';
import MenuDmts from './menuImportacao';
import MenuDlifDesalfandegamento from './menuDlifDesalfandegamento';
import MenuDlifLicenciamento from './menuDlifLicenciamento';
import VerifyPermission from '../../../utils/verifyPermission';
import MenuFarmacovigilancia from './menuFarmacovigilancia';
import MenuControleQualidade from './menuControleQualidade';
import MenuDmtsCertificadoProdutoControlado from './menuDmtsCertificadoProdutoControlado';
import { Alert, AlertTitle } from '@mui/material';
import MenuMedicamentos from './menuMedicamentos';
import ServicoExpedienteAreas from './servicoExpedienteAreas';
import ServicoReclamacoesAreas from './servicoReclamacoesAreas';

function SectionHeader({ title }) {
  return (
    <div className="tw-flex tw-items-center tw-gap-3 tw-px-5 tw-py-4 tw-bg-gradient-to-r tw-from-[#85287e]/10 tw-to-transparent tw-border-b tw-border-[#85287e]/20">
      <div className="tw-w-1.5 tw-h-7 tw-bg-[#85287e] tw-rounded-full tw-flex-shrink-0" />
      <h2 className="tw-text-[14px] tw-font-extrabold tw-tracking-widest tw-text-[#85287e] tw-uppercase tw-leading-none">
        {title}
      </h2>
    </div>
  );
}

export default function Menus() {
  const user = useSelector(state => state.account.user);

  return (
    <div className="tw-pb-12 tw-max-w-5xl tw-mx-auto tw-p-4">



      {user?.permissions?.length === 0 && (
        <Alert severity="warning" style={{ margin: 20 }}>
          <AlertTitle>Utilizador sem privilégios no sistema</AlertTitle>
        </Alert>
      )}

      <VerifyPermission permissions={user?.permissions} permission={'secçãoLicenciamento'} verificacaoSimples={true}>
        <section className="tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Licenciamento" />
          <MenuDlifLicenciamento>
            <ServicoReclamacoesAreas permissao='reclamacoesLicenciamento' nomeArea='DLIF' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteLicenciamento' nomeArea='DLIF' nomeService='Expediente' />
          </MenuDlifLicenciamento>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoCertificadoProdutoControlo'} verificacaoSimples={true}>
        <section className="tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Certificados para Produto Controlado" />
          <MenuDmtsCertificadoProdutoControlado>
            <ServicoReclamacoesAreas permissao='reclamacoesProdutoControlado' nomeArea='DCQMTS' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteProdutoControlado' nomeArea='DCQMTS' nomeService='Expediente' />
          </MenuDmtsCertificadoProdutoControlado>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoImportação'} verificacaoSimples={true}>
        <section className=" tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Importação" />
          <MenuDmts>
            <ServicoReclamacoesAreas permissao='reclamacoesImportacao' nomeArea='DLIF' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteImportacao' nomeArea='DLIF' nomeService='Expediente' />
          </MenuDmts>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoDesalfandegamento'} verificacaoSimples={true}>
        <section className=" tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Desalfandegamento" />
          <MenuDlifDesalfandegamento>
            <ServicoReclamacoesAreas permissao='reclamacoesDesalfandegamento' nomeArea='DLIF' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteDesalfandegamento' nomeArea='DLIF' nomeService='Expediente' />
          </MenuDlifDesalfandegamento>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoExpediente'} verificacaoSimples={true}>
        <section className=" tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Expediente" />
          <MenuExpediente>
            <ServicoReclamacoesAreas permissao='reclamacoesExpediente' nomeArea='DADG' nomeService='Reclamações' />
          </MenuExpediente>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoControleQualidade'} verificacaoSimples={true}>
        <section className=" tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Controlo de Qualidade" />
          <MenuControleQualidade>
            <ServicoReclamacoesAreas permissao='reclamacoesControloQualidade' nomeArea='DCQMTS' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteControloQualidade' nomeArea='DCQMTS' nomeService='Expediente' />
          </MenuControleQualidade>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoFarmacovigilância'} verificacaoSimples={true}>
        <section className=" tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Farmacovigilância" />
          <MenuFarmacovigilancia>
            <ServicoReclamacoesAreas permissao='reclamacoesFarmacovigilancia' nomeArea='DCQMTS' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteFarmacovigilancia' nomeArea='DCQMTS' nomeService='Expediente' />
          </MenuFarmacovigilancia>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoMedicamentos'} verificacaoSimples={true}>
        <section className=" tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-100 tw-mb-5 tw-overflow-hidden">
          <SectionHeader title="Registo de Medicamentos" />
          <MenuMedicamentos>
            <ServicoReclamacoesAreas permissao='reclamacoesMedicamentos' nomeArea='DCQMTS' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteMedicamentos' nomeArea='DCQMTS' nomeService='Expediente' />
          </MenuMedicamentos>
        </section>
      </VerifyPermission>

    </div>
  );
}
